<tui-root>
    <main class="px-0 md:px-8 xl:px-0 py-16">
    <section *ngIf="currentSurveyStep === 5">
        <div class="storenContainer mx-auto">
            <section *ngIf="currentSeasonSurveyStep === 1">
                <form class="bg-white px-0" [formGroup]="seasonSurveyForm">
                    <div>
                        <div>
                            <div class="text-[12px] text-right">* = Required</div>

                            <div class="grey-bottom-hr">
                                <h6 class="my-2 text-[26px] font-bold">Your Storen Experience</h6>
                            </div>
                            <p class="mt-2 text-[14px] text-neutral-500">The following questions are about Storen corn
                                herbicide and
                                your
                                plans for next season.</p>
                        </div>
                        <div class="tui-form__row mt-4" id="endOfSeason">
                            <p class="text-[16px] my-2 mb-3">Are you planning to use Storen corn herbicide again next
                                season?<span class="tui-required"></span></p>
                            <div class="border rounded-xl mt-1">
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Yes"
                                                formControlName="planToUseStorenNextSeason" class="color-blue" />
                                            <span class="ml-2">Yes</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="No"
                                                formControlName="planToUseStorenNextSeason" class="color-blue" />
                                            <span class="ml-2">No</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Unsure"
                                                formControlName="planToUseStorenNextSeason" class="color-blue" />
                                            <span class="ml-2">Unsure</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row">
                            <p class="text-[16px] my-2 mt-5 mb-3">Would you recommend Storen corn herbicide to other growers?<span
                                    class="tui-required"></span></p>
                            <div class="border rounded-xl mt-1">
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Yes"
                                                formControlName="recommendStorenToOtherGrowers" class="color-blue" />
                                            <span class="ml-2">Yes</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="No"
                                                formControlName="recommendStorenToOtherGrowers" class="color-blue" />
                                            <span class="ml-2">No</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row">
                            <p class="text-[16px] my-2 mb-3 mt-5">How satisfied are you with Storen compared to your previous
                                corn
                                herbicide?</p>
                            <div class="border rounded-xl mt-1">
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="More satisfied"
                                                formControlName="satisfactionWithStorenVsPreviousHerbicide"
                                                class="color-blue" />
                                            <span class="ml-2">More satisfied</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Equally satisfied"
                                                formControlName="satisfactionWithStorenVsPreviousHerbicide"
                                                class="color-blue" />
                                            <span class="ml-2">Equally satisfied</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Less satisfied"
                                                formControlName="satisfactionWithStorenVsPreviousHerbicide"
                                                class="color-blue" />
                                            <span class="ml-2">Less satisfied</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row">
                            <p class="text-[16px] mb-1 mt-5">Please share any other comments you have about your
                                experience
                                with
                                Storen this season.</p>
                            <p class="text-[16px] mb-1 text-muted">(Minimum 50 characters)</p>
                            <tui-textarea formControlName="additionalCommentsAboutStorenExperience" (change)="charSubstring(seasonSurveyForm.value.additionalCommentsAboutStorenExperience,'additionalCommentsAboutStorenExperience')"
                                [tuiTextfieldLabelOutside]="true" class="textCustom" (keypress)="characValidation(seasonSurveyForm.value.additionalCommentsAboutStorenExperience)"/>
                                <p class="text-[16px] mb-1 mt-2 text-muted text-danger"
                                 *ngIf="seasonSurveyForm.controls['additionalCommentsAboutStorenExperience']?.errors">Enter at least 50 characters.</p>
                                 <div class="counter">{{additionalCommentsLength || 0}}/1000</div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="grey-bottom-hr">
                                <h6 class="my-2 text-[26px] font-bold mt-5 mb-2">Your Storen Satisfaction Program Experience
                                </h6>
                            </div>
                            <p class="mt-2 text-[14px] text-neutral-500">The following questions are about the Storen
                                Satisfaction
                                Program.</p>
                        </div>

                        <div class="tui-form__row">
                            <p class="text-[16px] my-2 mb-3 mt-5">How would you rate the amount of communication we’ve sent
                                you
                                related to the Storen Satisfaction Program?<span class="tui-required"></span></p>
                            <div class="border rounded-xl mt-1">
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Too much"
                                                formControlName="communicationRatingForStorenProgram"
                                                class="color-blue" />
                                            <span class="ml-2">Too much</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Too little"
                                                formControlName="communicationRatingForStorenProgram"
                                                class="color-blue" />
                                            <span class="ml-2">Too little</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiRadio type="radio" value="Just right"
                                                formControlName="communicationRatingForStorenProgram"
                                                class="color-blue" />
                                            <span class="ml-2">Just right</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="tui-form__row  mt-5">
                            <p class="text-[16px] my-2 mb-3">On a scale from 1 to 5, how easy was it to participate in the
                                Storen
                                Satisfaction Program (registering, answering questions, submitting photos, etc.)?
                                <span class="tui-required"></span>
                            </p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="easeOfParticipationInStorenProgram" class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very difficult</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="easeOfParticipationInStorenProgram" class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Difficult</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="easeOfParticipationInStorenProgram" class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Neutral</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="easeOfParticipationInStorenProgram" class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Easy</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="easeOfParticipationInStorenProgram" class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very easy</span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row  mt-5">
                            <p class="text-[16px] my-2 mb-3">On a scale from 1 to 5, how would you rate the Storen-branded
                                rewards
                                you’ve earned throughout the Storen Satisfaction Program?<span
                                    class="tui-required"></span></p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="ratingForStorenRewards" class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very poor</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="ratingForStorenRewards" class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Poor</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="ratingForStorenRewards" class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Average</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="ratingForStorenRewards" class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Good</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="ratingForStorenRewards" class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Excellent</span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row  mt-5">
                            <p class="text-[16px] my-2 mb-3">On a scale from 1 to 5, how satisfied were you with the Storen
                                Satisfaction Program overall?<span class="tui-required"></span></p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="overallSatisfactionWithStorenProgram" class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very dissatisfied</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="overallSatisfactionWithStorenProgram" class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Dissatisfied</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="overallSatisfactionWithStorenProgram" class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Neutral</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="overallSatisfactionWithStorenProgram" class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Satisfied</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="overallSatisfactionWithStorenProgram" class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very satisfied</span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row">
                            <p class="text-[16px] mb-1 mt-5">Please share any other comments, suggestions, or
                                improvements
                                you have for the Storen Satisfaction Program:</p>
                            <tui-textarea formControlName="additionalFeedbackForStorenProgram" (change)="charSubstring(seasonSurveyForm.value.additionalFeedbackForStorenProgram,'additionalFeedbackForStorenProgram')"
                                [tuiTextfieldLabelOutside]="true" (keypress)="characValidation(seasonSurveyForm.value.additionalFeedbackForStorenProgram)"/>
                                <div class="counter">{{additionalFeedBackLength || 0}}/1000</div>
                        </div>

                        <div class="tui-form__row">
                            <p class="text-[16px] my-2 mb-3 mt-5">Your feedback makes a difference! Thank you for sharing your
                                experience. Choose your reward below.<span class="tui-required"></span></p>
                            <div
                                class="max-w-6xl mx-auto flex items-start md:items-center justify-center gap-3 md:gap-10">
                                <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                    <div
                                        class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                        <img src="../assets/hat.png" alt="Reward 1"
                                            class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                    </div>
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex flex-col items-center">
                                            <input tuiRadio type="radio" value="Storen Hat"
                                                [formControl]="seasonSurveyForm.controls['selectedRewardOption']"
                                                class="color-blue" />
                                            <span class="mt-2">Storen Hat</span>
                                        </div>
                                    </label>
                                </div>

                                <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                    <div
                                        class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                        <img src="../assets/beanie.png" alt="Reward 2"
                                            class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                    </div>
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex flex-col items-center">
                                            <input tuiRadio type="radio" value="Storen Beanie"
                                                [formControl]="seasonSurveyForm.controls['selectedRewardOption']"
                                                class="color-blue" />
                                            <span class="mt-2">Storen Beanie</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="tui-form__row">
                            <button (click)="submitEndOfSeasonSurvey()" tuiButton appearance="" size="m" type="button"
                                class="blue-hover-effect rounded-0 w-full font-bold text-[#FFFFFF] bg-dark-blue"[disabled]="!seasonSurveyForm.valid">
                                Submit
                            </button>
                        </div>

                    </div>
                </form>
            </section>
            <section class="bg-white mb-5" *ngIf="currentSeasonSurveyStep === 2">
                <div class="row mt-5" id="seasonThanks">
                    <div class="mx-auto">
                        <div class="text-center">
                            <div class="my-4 flex justify-center items-center">
                                <img src="../assets/Check.png" alt="" class="w-[92px] h-[92px]">
                            </div>
                            <div class="my-4">
                                <p class="text-[36px] font-bold leading-[37px]">Thank you for your submission!</p>
                                <div class="flex flex-col gap-2 mt-4 text-neutral-500">
                                    <p class="text-[16px] leading-[24px]">Your participation in the Storen
                                        Satisfaction
                                        Program is now complete! Your selected reward will be shipped to the address
                                        provided during sign-up. You’ll receive an email confirmation once your
                                        reward
                                        has shipped.*</p>
                                    <p class="text-[16px] leading-[24px] mt-4">Limit one (1) Storen hat or beanie per
                                        eligible participant.</p>
                                    <p class="text-[16px] leading-[24px] underline"><a href="">View full program terms and conditions.</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="m-3">
                            <button (click)="returnToMainDashboard()" tuiButton appearance="primary-grayscale"
                                size="m" class="rounded-0 text-white w-100 dark-btn-hover">
                                Return to Dashboard
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </section>
    </main>
</tui-root>